import { render, staticRenderFns } from "./GalleryViewHeader.vue?vue&type=template&id=0cd0a56c&"
import script from "./GalleryViewHeader.vue?vue&type=script&lang=js&"
export * from "./GalleryViewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd0a56c')) {
      api.createRecord('0cd0a56c', component.options)
    } else {
      api.reload('0cd0a56c', component.options)
    }
    module.hot.accept("./GalleryViewHeader.vue?vue&type=template&id=0cd0a56c&", function () {
      api.rerender('0cd0a56c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GalleryView/GalleryViewHeader.vue"
export default component.exports